const config = {
  backendUrl: process.env.REACT_APP_BACKEND_URL,
  appGalleryBackendUrl: process.env.REACT_APP_GALLERY_BACKEND_URL,
  internalMessagingBackendUrl: process.env.REACT_APP_INTERNAL_MESSAGING_BACKEND_URL,
  environmentMarker: process.env.REACT_APP_ENVIRONMENT_MARKER,
  universeBackendUrl: process.env.REACT_APP_UNIVERSE_BACKEND_URL,
  universeFrontendUrl: process.env.REACT_APP_UNIVERSE_FRONTEND_URL,
  trackingAppId: process.env.REACT_APP_TRACKING_APP_ID,
};

export default config;
